import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { getFarmer } from "../../../redux/reducer/farmer/farmerReducer";
import NumberFormatting from "../../helper/NumberFormatting";
import {
  debtPlasticActions,
  getDebtPlasticById,
  updateDebtPlastic,
} from "../../../redux/reducer/debtPlastic/debtPlasticReducer";
import { sortGoodsOperational } from "../../../redux/reducer/goodsOperational/goodsOperationalReducer";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function FarmerDebtPlasticEdit() {
  // Navigate
  const { id } = useParams();
  const navigate = useNavigate();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const farmer = useSelector((state) => state.farmer.data);
  const debtPlastic = useSelector((state) => state.debtPlastic.data);

  // Local State
  const [formData, setFormData] = useState({
    farmerId: "",
    goodsOperationalId: "",
    quantity: "",
    totalDebt: "",
  });
  const [fetch, setFetch] = useState(true);
  const [goodsOperational, setGoodsOperational] = useState([]);

  useEffect(() => {
    if (fetch) {
      let filterData = {
        token: token,
        body: {
          isActive: true,
        },
        params: {
          paginate: false,
        },
      };
      dispatch(sortGoodsOperational(filterData))
        .then((res) => {
          if (res.payload.status === 200) {
            let barangKategoriPlastik = res.payload.data.docs.filter(
              (item) =>
                item.categoryId.categoryName.toLowerCase() === "plastik" ||
                item.categoryId.categoryName.toLowerCase() === "plastic"
            );
            setGoodsOperational([...barangKategoriPlastik]);
          }
        })
        .catch();
      const x = debtPlastic.docs.findIndex((item) => item._id === id);
      if (x > -1) {
        setFormData({
          farmerId: debtPlastic.docs[x].farmerId
            ? debtPlastic.docs[x].farmerId
            : "",
          goodsOperationalId: debtPlastic.docs[x].goodsOperationalId._id
            ? debtPlastic.docs[x].goodsOperationalId._id
            : "",
          quantity: debtPlastic.docs[x].quantity
            ? debtPlastic.docs[x].quantity
            : "",
          totalDebt: debtPlastic.docs[x].totalDebt
            ? debtPlastic.docs[x].totalDebt
            : "",
        });
      }
      setFetch(false);
    }
  }, [fetch]);

  // Basic Handle Change
  const handleChange = (e) => {
    if (e.target.name === "quantity") {
      setFormData({
        ...formData,
        quantity: e.target.value,
        totalDebt:
          parseInt(formData.goodsOperationalId.priceOfGoods) *
          parseInt(e.target.value),
      });
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          value: {
            farmerId: formData.farmerId._id,
            goodsOperationalId: formData.goodsOperationalId._id,
            quantity: formData.quantity,
            paymentDetails: {
              totalDebt: formData.totalDebt,
            },
          },
          id: id,
          token: token,
        };
        dispatch(updateDebtPlastic(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getDebtPlasticById(dataGetById)).then((result) => {
              dispatch(debtPlasticActions.editDebtPlastic(result.payload.data));
              toast.success(res.payload.message);
              navigate("/petani/hutang-plastik");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (farmer.totalDocs !== farmer.docs.length && value === 1) {
        const getData = {
          params: {
            limit: farmer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getFarmer(getData));
      }
    }
  };

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          EDIT HUTANG PLASTIK
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
          onSubmit={handleSubmitAll}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PETANI
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="farmerId"
              onChange={handleChange}
              value={formData.farmerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              <MenuItem value={formData.farmerId}>
                {formData.farmerId.fullName}
              </MenuItem>
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              BARANG
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="goodsOperationalId"
              onChange={handleChange}
              value={formData.goodsOperationalId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {goodsOperational.length > 0 ? (
                goodsOperational.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.nameOfGoods}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              marginBottom: "10px",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              JUMLAH
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{
                style: { background: "white", paddingLeft: "5px" },
              }}
              InputProps={{
                inputComponent: NumberFormatting,
                startAdornment: (
                  <InputAdornment position="start">Qty. </InputAdornment>
                ),
              }}
              required
              size="small"
              name="quantity"
              onChange={handleChange}
              value={formData.quantity}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              marginBottom: "10px",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TOTAL HUTANG
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              onChange={handleChange}
              value={formData.totalDebt.toLocaleString("id", {
                style: "currency",
                currency: "IDR",
              })}
              name="totalDebt"
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/petani/hutang-plastik")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
